type TelegramContextWindow = Window & {
  TelegramWebviewProxy?: { postEvent?: unknown };
};

let telegramLaunch = false;

export const hasTelegramLaunchParameters = (): boolean => {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  return /^\d+(\.\d+)*$/.test(hash.get('tgWebAppVersion') ?? '')
    && Boolean(hash.get('tgWebAppPlatform'));
};

export const hasNativeTelegramBridge = (): boolean => {
  const telegramWindow = window as TelegramContextWindow;
  const external = window.external as External & { notify?: unknown };

  return typeof telegramWindow.TelegramWebviewProxy?.postEvent === 'function'
    || typeof external?.notify === 'function';
};

// Only a boolean survives SPA navigation. Do not retain launch tokens or initData.
export const captureTelegramCheckoutContext = (): void => {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const query = new URLSearchParams(window.location.search);
  telegramLaunch = telegramLaunch || hasNativeTelegramBridge()
    || Boolean(hash.get('tgWebAppData')) || Boolean(hash.get('tgWebAppPlatform'))
    || Boolean(query.get('tgWebAppData')) || Boolean(query.get('tgWebAppPlatform'));
};

export const hasTelegramCheckoutContext = (): boolean => {
  captureTelegramCheckoutContext();
  return telegramLaunch;
};
